<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router';
import { usePlgPlanSdk } from '@eureka/shared/plg-plan/src/composables/use-plg-plan-sdk';

const router = useRouter();
const route = useRoute();

// 初始化支付 SDK，处理 payment_state=success 回调
const { openPlgPlanDialog, openSuccessDialog } = usePlgPlanSdk({
    router,
    route,
});

// 暴露到全局 window，方便调试和调用
(window as any).openPaymentDialog = () => {
    // 使用完整的 window.location 而不是 route.path，确保包含 /vault/ 路径
    const currentUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
    const baseSuccessUrl = currentUrl.includes('?')
        ? `${currentUrl}&payment_state=success`
        : `${currentUrl}?payment_state=success`;
    const baseCancelUrl = currentUrl.includes('?')
        ? `${currentUrl}&payment_state=cancel`
        : `${currentUrl}?payment_state=cancel`;

    openPlgPlanDialog({
        successUrl: baseSuccessUrl,
        cancelUrl: baseCancelUrl,
        viewMoreUrl: window.location.origin,
    });
};
(window as any).openSuccessDialog = openSuccessDialog;

// 暴露给全局使用（可选）
defineExpose({
    openPlgPlanDialog,
    openSuccessDialog,
});
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  height: 100%;
  width: 100%;
}

.app-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
